(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/swipe-arrows/assets/javascripts/swipe-arrows.js') >= 0) return;  svs.modules.push('/components/sport/swipe-arrows/assets/javascripts/swipe-arrows.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const ReactIcon = svs.ui.ReactIcon;
const SwipeArrows = _ref => {
  let _ref$arrowVerticalPad = _ref.arrowVerticalPadding,
    arrowVerticalPadding = _ref$arrowVerticalPad === void 0 ? 80 : _ref$arrowVerticalPad,
    getLeftScrollWidth = _ref.getLeftScrollWidth,
    getRightScrollWidth = _ref.getRightScrollWidth,
    _ref$leftArrowClassNa = _ref.leftArrowClassName,
    leftArrowClassName = _ref$leftArrowClassNa === void 0 ? '' : _ref$leftArrowClassNa,
    _ref$rightArrowClassN = _ref.rightArrowClassName,
    rightArrowClassName = _ref$rightArrowClassN === void 0 ? '' : _ref$rightArrowClassN,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
    scrollContentEl = _ref.scrollContentEl,
    scrollParentSelector = _ref.scrollParentSelector,
    _ref$leftArrowOffset = _ref.leftArrowOffset,
    leftArrowOffset = _ref$leftArrowOffset === void 0 ? 0 : _ref$leftArrowOffset;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    renderLeftArrow = _useState2[0],
    setRenderLeftArrow = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    renderRightArrow = _useState4[0],
    setRenderRightArrow = _useState4[1];
  const _useState5 = useState(arrowVerticalPadding),
    _useState6 = _slicedToArray(_useState5, 2),
    topOffset = _useState6[0],
    setTopOffset = _useState6[1];
  const arrowContainerRef = useRef(null);
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);
  const handleArrowClick = direction => {
    if (!scrollContentEl) {
      return;
    }
    scrollContentEl.scrollTo({
      'scroll-behavior': 'smooth',
      left: direction === 'right' ? getRightScrollWidth() : getLeftScrollWidth()
    });
  };
  useEffect(() => {
    if (scrollContentEl) {
      setTopOffset(scrollContentEl.scrollHeight / 2);
    }
  }, [scrollContentEl]);
  useEffect(() => {
    const handleArrowScrolls = () => {
      const scrollWidth = scrollContentEl.scrollWidth;
      const scrollLeft = scrollContentEl.scrollLeft;
      const holderWidth = scrollContentEl.clientWidth;
      const scrollLength = scrollWidth - holderWidth;
      if (holderWidth >= scrollWidth) {
        setRenderLeftArrow(false);
        setRenderRightArrow(false);
      } else if (scrollLeft === 0) {
        setRenderLeftArrow(false);
        setRenderRightArrow(true);
      } else if (scrollLeft >= scrollLength - 5) {
        setRenderLeftArrow(true);
        setRenderRightArrow(false);
      } else if (scrollLeft > 0) {
        setRenderLeftArrow(true);
        setRenderRightArrow(true);
      } else {
        setRenderLeftArrow(false);
        setRenderRightArrow(false);
      }
    };
    const handleArrowPlacement = () => {
      const parentScrollOffset = scrollParentSelector ? document.querySelector(scrollParentSelector).scrollTop : window.pageYOffset;
      const scrollContentHeight = scrollContentEl.scrollHeight;
      if (parentScrollOffset > arrowVerticalPadding && parentScrollOffset < scrollContentHeight - arrowVerticalPadding) {
        setTopOffset(scrollContentHeight / 2);
      }
    };
    if (!scrollContentEl) {
      return;
    }
    let resizeTimer;
    scrollContentEl.addEventListener('scroll', handleArrowScrolls);
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        handleArrowScrolls();
      }, 250);
    });
    handleArrowScrolls();
    const scrollParent = scrollParentSelector ? document.querySelector(scrollParentSelector) : window;
    scrollParent.addEventListener('scroll', handleArrowPlacement);
    return () => {
      scrollContentEl.removeEventListener('scroll', handleArrowScrolls);
      window.removeEventListener('resize', handleArrowScrolls);
      scrollParent.removeEventListener('scroll', handleArrowPlacement);
    };
  }, [arrowVerticalPadding, scrollContentEl, scrollParentSelector]);
  return React.createElement("div", {
    className: "swipe-arrow-container ".concat(containerClassName),
    ref: arrowContainerRef,
    style: {
      transform: "translateY(".concat(topOffset, "px)")
    }
  }, renderLeftArrow && React.createElement("div", {
    className: "left-arrow ".concat(leftArrowClassName),
    onClick: () => handleArrowClick('left'),
    ref: leftArrowRef,
    style: {
      transform: "translateX(".concat(leftArrowOffset, "px)")
    }
  }, React.createElement(ReactIcon, {
    color: "fc-black",
    icon: "badge-arrow-left",
    size: "600"
  })), renderRightArrow && React.createElement("div", {
    className: "right-arrow ".concat(rightArrowClassName),
    onClick: () => handleArrowClick('right'),
    ref: rightArrowRef
  }, React.createElement(ReactIcon, {
    color: "fc-black",
    icon: "badge-arrow-right",
    size: "600"
  })));
};
svs.sport.swipeArrows.SwipeArrows = SwipeArrows;

 })(window);